export type IClassNameValue = string | boolean | number | null | undefined;

export type IClassNameCollection = Record<string, IClassNameValue>;

export type IClassName = IClassNameCollection | IClassNameValue;
